(() => {
  'use strict';

  if (window.StookrijkExperienceLoaded) return;
  window.StookrijkExperienceLoaded = true;

  const money = new Intl.NumberFormat('nl-NL', {
    style: 'currency',
    currency: 'EUR',
    maximumFractionDigits: 0
  });

  function initQuiz(scope = document) {
    scope.querySelectorAll('[data-oven-quiz]:not([data-ready])').forEach((quiz) => {
      quiz.dataset.ready = 'true';
      const form = quiz.querySelector('form');
      const target = quiz.querySelector('[data-quiz-results]');
      if (!form || !target) return;

      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const data = new FormData(form);
        const people = Number(data.get('people') || 4);
        const heat = data.get('heat');
        const style = data.get('style');
        const dish = data.get('dish');
        let results;

        if (heat === 'long' || people >= 8 || dish === 'slow') {
          results = [
            ['Leiria Geïsoleerd', 'Sterk in warmtebehoud en veelzijdig voor langere kooksessies.'],
            ['Toscano', 'Royale oven voor uitgebreid koken en een uitgesproken afwerking.'],
            ['Gold Cortiça', 'Extra karakter en isolerende kurkafwerking voor de enthousiaste buitenkok.']
          ];
        } else if (style === 'exclusive') {
          results = [
            ['Rustico', 'Een krachtige blikvanger met een robuuste, natuurlijke uitstraling.'],
            ['Tagália Black', 'Strak en donker voor een moderne tuin of buitenkeuken.'],
            ['Tagália White', 'Licht en architectonisch met een rustige, moderne vorm.']
          ];
        } else {
          results = [
            ['Leiria', 'Een toegankelijke allrounder voor pizza, brood en ovengerechten.'],
            ['Classico', 'Traditionele uitstraling en een fijne maat voor regelmatig gebruik.'],
            ['Steenoven Standaard', 'Een heldere instap wanneer prijs en snel genieten vooropstaan.']
          ];
        }

        target.innerHTML = results.map(([name, reason]) => {
          const url = `/search?type=product&q=${encodeURIComponent(name)}`;
          return `<article class="sr-result-card"><strong>${name}</strong><span>${reason}</span><br><a class="text-link text-link--light" href="${url}">Bekijk dit model</a></article>`;
        }).join('');
        target.closest('.sr-tool__result')?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    });
  }

  function initProjectFilters(scope = document) {
    scope.querySelectorAll('[data-project-browser]:not([data-ready])').forEach((browser) => {
      browser.dataset.ready = 'true';
      const filters = browser.querySelectorAll('[data-project-filter]');
      const cards = browser.querySelectorAll('[data-project-tags]');
      filters.forEach((button) => {
        button.addEventListener('click', () => {
          const value = button.dataset.projectFilter;
          filters.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
          cards.forEach((card) => {
            const tags = (card.dataset.projectTags || '').split(',').map((tag) => tag.trim());
            card.hidden = value !== 'all' && !tags.includes(value);
          });
        });
      });
    });
  }

  function initConfigurator(scope = document) {
    scope.querySelectorAll('[data-kitchen-configurator]:not([data-ready])').forEach((configurator) => {
      configurator.dataset.ready = 'true';
      const form = configurator.querySelector('form');
      const steps = [...configurator.querySelectorAll('[data-config-step]')];
      const progress = [...configurator.querySelectorAll('[data-progress-segment]')];
      const previous = configurator.querySelector('[data-config-previous]');
      const next = configurator.querySelector('[data-config-next]');
      const submit = configurator.querySelector('[data-config-submit]');
      const minOutput = configurator.querySelector('[data-price-output-min]');
      const maxOutput = configurator.querySelector('[data-price-output-max]');
      const priceSeparator = configurator.querySelector('[data-price-separator]');
      const hiddenSummary = configurator.querySelector('[data-summary-field]');
      const hiddenCode = configurator.querySelector('[data-code-field]');
      const preview = configurator.querySelector('[data-kitchen-preview]');
      const error = configurator.querySelector('[data-step-error]');
      const storageKey = `stookrijk-kitchen-v2-${configurator.dataset.sectionId}`;
      const pricing = window.StookrijkConfiguratorPricing;
      let current = 0;
      let currentPrice = { min: 0, max: 0, breakdown: {} };

      if (!form || steps.length === 0 || !pricing?.calculate) return;
      form.noValidate = true;

      const idPrefix = form.id || `KitchenConfigurator-${configurator.dataset.sectionId || 'section'}`;
      steps.forEach((step, index) => {
        const heading = step.querySelector('h3');
        if (!heading) return;
        if (!heading.id) heading.id = `${idPrefix}-StepHeading-${index + 1}`;
        step.setAttribute('role', 'group');
        step.setAttribute('aria-labelledby', heading.id);
      });

      function selectedRadio(name) {
        return form.querySelector(`[name="${CSS.escape(name)}"]:checked`);
      }

      function selectedOption(name) {
        const select = form.elements.namedItem(name);
        return select?.selectedOptions?.[0] || null;
      }

      function selectedValue(name) {
        return selectedRadio(name)?.value || selectedOption(name)?.value || form.elements.namedItem(name)?.value || '';
      }

      function numberValue(name) {
        return Number(form.elements.namedItem(name)?.value || 0);
      }

      function rangeFrom(element, prefix = '') {
        if (!element) return { min: 0, max: 0 };
        const key = prefix ? `${prefix[0].toUpperCase()}${prefix.slice(1)}` : '';
        const minimum = Number(element.dataset[`${prefix}Min`] ?? element.dataset[`price${key}Min`] ?? 0);
        const maximum = Number(element.dataset[`${prefix}Max`] ?? element.dataset[`price${key}Max`] ?? minimum);
        return {
          min: Number.isFinite(minimum) ? minimum : 0,
          max: Number.isFinite(maximum) ? maximum : (Number.isFinite(minimum) ? minimum : 0)
        };
      }

      function framePricing(frame) {
        if (!frame) return null;
        const pair = (name) => ({ min: Number(frame.dataset[`${name}Min`] || 0), max: Number(frame.dataset[`${name}Max`] || frame.dataset[`${name}Min`] || 0) });
        return {
          perMetre: pair('meter'),
          depthStep: pair('depthStep'),
          door: pair('door'),
          shelf: pair('shelf'),
          drawerOne: pair('drawerOne'),
          drawerTwo: pair('drawerTwo'),
          sidePanel: pair('side'),
          rearWall: pair('rear')
        };
      }

      function syncShapeUi() {
        const isLShape = selectedValue('config_vorm') === 'L-vorm';
        preview?.classList.toggle('is-l', isLShape);
        const lengthB = form.querySelector('[data-length-b]');
        const lengthBInput = form.querySelector('[name="config_lengte_b"]');
        if (lengthB) lengthB.hidden = !isLShape;
        if (lengthBInput) {
          lengthBInput.disabled = !isLShape;
          lengthBInput.required = isLShape;
        }
      }

      function formatRange(item) {
        if (!item || (!item.min && !item.max)) return '';
        return item.min === item.max ? money.format(item.min) : `${money.format(item.min)} tot ${money.format(item.max)}`;
      }

      function renderBreakdown(breakdown) {
        Object.entries(breakdown).forEach(([key, value]) => {
          const row = configurator.querySelector(`[data-breakdown-row="${key}"]`);
          const output = configurator.querySelector(`[data-breakdown-value="${key}"]`);
          const hasValue = Number(value?.min || 0) !== 0 || Number(value?.max || 0) !== 0;
          if (row) row.hidden = !hasValue;
          if (output) output.textContent = hasValue ? formatRange(value) : '';
        });
      }

      function calculate() {
        const isLShape = selectedValue('config_vorm') === 'L-vorm';
        const lengthA = Math.max(0, numberValue('config_lengte_a'));
        const lengthB = isLShape ? Math.max(0, numberValue('config_lengte_b')) : 0;
        const frame = selectedRadio('config_kader');
        const worktop = selectedRadio('config_werkblad');
        const equipment = [...form.querySelectorAll('input[name^="config_optie_"]:checked')].map((input) => rangeFrom(input, 'price'));

        currentPrice = pricing.calculate({
          metres: (lengthA + lengthB) / 100,
          depth: Number(selectedOption('config_diepte')?.dataset.depth || 70),
          frame: framePricing(frame),
          worktop: worktop ? { min: Number(worktop.dataset.meterMin || 0), max: Number(worktop.dataset.meterMax || worktop.dataset.meterMin || 0) } : null,
          doors: numberValue('config_deuren'),
          shelves: numberValue('config_planken'),
          drawers: Number(selectedOption('config_lades')?.dataset.drawerCount || 0),
          sidePanels: numberValue('config_zijpanelen'),
          rearWall: Boolean(form.querySelector('[name="config_achterwand"]:checked')),
          equipment
        });

        if (minOutput) minOutput.textContent = money.format(currentPrice.min);
        const isRange = currentPrice.min !== currentPrice.max;
        if (maxOutput) {
          maxOutput.hidden = !isRange;
          maxOutput.textContent = money.format(currentPrice.max);
        }
        if (priceSeparator) priceSeparator.hidden = !isRange;
        configurator.dataset.currentMin = String(currentPrice.min);
        configurator.dataset.currentMax = String(currentPrice.max);
        renderBreakdown(currentPrice.breakdown);
        return currentPrice;
      }

      function makeCode() {
        const stamp = new Date().toISOString().slice(0, 10).replaceAll('-', '');
        const random = Math.random().toString(36).slice(2, 6).toUpperCase();
        return `SR-${stamp}-${random}`;
      }

      function buildSummary() {
        const entries = [];
        const seen = new Set();
        [...form.elements].forEach((element) => {
          if (!element.name?.startsWith('config_') || element.type === 'hidden' || element.disabled) return;
          if ((element.type === 'radio' || element.type === 'checkbox') && !element.checked) return;
          if (!element.value || seen.has(element.name)) return;
          const label = element.dataset.label || element.name.replace('config_', '').replaceAll('_', ' ');
          entries.push([label, element.value]);
          if (element.type !== 'checkbox') seen.add(element.name);
        });

        const code = hiddenCode?.value || makeCode();
        if (hiddenCode) hiddenCode.value = code;
        const priceLine = currentPrice.min === currentPrice.max
          ? `Prijsindicatie: ${money.format(currentPrice.min)}`
          : `Prijsindicatie: ${money.format(currentPrice.min)} tot ${money.format(currentPrice.max)}`;
        const breakdownLines = Object.entries(currentPrice.breakdown || {})
          .filter(([, value]) => value.min || value.max)
          .map(([key, value]) => `${({ frame: 'Kader en diepte', worktop: 'Werkblad', storage: 'Indeling en afwerking', equipment: 'Apparatuur' })[key]}: ${formatRange(value)}`);
        const text = [`Aanvraagcode: ${code}`, priceLine, ...breakdownLines, ...entries.map(([label, value]) => `${label}: ${value}`)].join('\n');
        if (hiddenSummary) hiddenSummary.value = text;
        const body = form.querySelector('[data-contact-body]');
        if (body) body.value = text;
      }

      function save() {
        const values = {};
        [...form.elements].forEach((element) => {
          if (!element.name?.startsWith('config_')) return;
          if (element.type === 'checkbox') {
            values[element.name] ||= [];
            if (element.checked) values[element.name].push(element.value);
          } else if (element.type === 'radio') {
            if (element.checked) values[element.name] = element.value;
          } else {
            values[element.name] = element.value;
          }
        });
        values.__state = { currentStep: current, requestCode: hiddenCode?.value || '' };
        try { localStorage.setItem(storageKey, JSON.stringify(values)); } catch (_error) { /* Storage can be unavailable. */ }
      }

      function restore() {
        let values;
        try { values = JSON.parse(localStorage.getItem(storageKey) || '{}'); } catch (_error) { values = {}; }
        if (!values || typeof values !== 'object' || Array.isArray(values)) values = {};
        const savedState = values.__state && typeof values.__state === 'object' ? values.__state : {};
        Object.entries(values).forEach(([name, value]) => {
          if (name === '__state') return;
          form.querySelectorAll(`[name="${CSS.escape(name)}"]`).forEach((element) => {
            if (element.type === 'checkbox') element.checked = Array.isArray(value) && value.includes(element.value);
            else if (element.type === 'radio') element.checked = element.value === value;
            else element.value = value;
          });
        });
        if (hiddenCode && typeof savedState.requestCode === 'string') hiddenCode.value = savedState.requestCode;
        const restoredStep = Number(savedState.currentStep);
        return Number.isInteger(restoredStep) ? restoredStep : 0;
      }

      function clearStepError() {
        if (error) error.textContent = '';
        form.querySelectorAll('[data-config-invalid]').forEach((field) => {
          field.removeAttribute('aria-invalid');
          field.removeAttribute('data-config-invalid');
        });
      }

      function markInvalid(field) {
        field.setAttribute('aria-invalid', 'true');
        field.setAttribute('data-config-invalid', '');
      }

      function findInvalidField(step) {
        return [...step.querySelectorAll('input, select, textarea')].find((field) => field.willValidate && !field.checkValidity());
      }

      function validateStep() {
        clearStepError();
        const field = findInvalidField(steps[current]);
        if (!field) return true;
        if (field.type === 'radio') {
          steps[current].querySelectorAll(`[name="${CSS.escape(field.name)}"]`).forEach(markInvalid);
          if (error) error.textContent = 'Kies eerst een optie om verder te gaan.';
          field.focus();
        } else {
          markInvalid(field);
          if (error) error.textContent = 'Vul de gemarkeerde gegevens in om verder te gaan.';
          field.reportValidity();
        }
        return false;
      }

      function showStep(index, { focusHeading = false, persist = true } = {}) {
        current = Math.max(0, Math.min(index, steps.length - 1));
        steps.forEach((step, position) => { step.hidden = position !== current; });
        progress.forEach((segment, position) => {
          segment.classList.toggle('is-complete', position < current);
          segment.classList.toggle('is-current', position === current);
        });
        if (previous) previous.hidden = current === 0;
        if (next) next.hidden = current === steps.length - 1;
        if (submit) submit.hidden = current !== steps.length - 1;
        const currentStepOutput = configurator.querySelector('[data-current-step]');
        if (currentStepOutput) currentStepOutput.textContent = String(current + 1);
        if (current >= 8) buildSummary();
        if (persist) save();
        if (focusHeading) steps[current].querySelector('h3')?.focus({ preventScroll: true });
      }

      form.addEventListener('change', (event) => {
        if (event.target.name === 'config_vorm') syncShapeUi();
        clearStepError();
        calculate();
        buildSummary();
        save();
      });
      form.addEventListener('input', () => {
        clearStepError();
        calculate();
        buildSummary();
        save();
      });
      form.addEventListener('submit', (event) => {
        const invalidStep = steps.findIndex((step) => findInvalidField(step));
        if (invalidStep >= 0) {
          event.preventDefault();
          showStep(invalidStep, { focusHeading: false });
          validateStep();
          return;
        }
        buildSummary();
        try { localStorage.removeItem(storageKey); } catch (_error) { /* Storage can be unavailable. */ }
      });
      next?.addEventListener('click', () => { if (validateStep()) showStep(current + 1, { focusHeading: true }); });
      previous?.addEventListener('click', () => {
        clearStepError();
        showStep(current - 1, { focusHeading: true });
      });

      const restoredStep = restore();
      syncShapeUi();
      calculate();
      buildSummary();
      showStep(restoredStep, { focusHeading: false, persist: false });
    });
  }

  function init(scope = document) {
    initQuiz(scope);
    initProjectFilters(scope);
    initConfigurator(scope);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
